import { AiOutlineCopyrightCircle } from 'react-icons/ai'
import { BsFacebook, BsInstagram } from "react-icons/bs";
import logo from '../img/yeti.png'; // Aquí pones el logo correcto de Incaprosa
import { NavLink } from 'react-router-dom';

const StickyFooter = () => {
  return (
    <footer>
      <section className="section-footer-incaprosa">
        <div className="container">
          <div className="grid-footer">

            {/* Columna 1 */}
            <div>
              <picture>
                <img className="logo-incaprosa" src={logo} alt="Incaprosa" />
              </picture>
              <div className="footer-block">
                <p className="footer-title">Repuestos</p>
                <ul className="footer-list">
                  <li>Automotrices</li>
                  <li>Industriales</li>
                  <li>Aceros</li>
                </ul>
              </div>
              <div className="footer-block">
                <p className="footer-title">Redes sociales</p>
                <div className="footer-social">
                  <NavLink to="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                    <BsFacebook />
                  </NavLink>
                  <NavLink to="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <BsInstagram />
                  </NavLink>
                </div>
              </div>
            </div>

            {/* Columna 2 */}
            <div>
              <div className="footer-block">
                <p className="footer-title">Oficinas centrales</p>
                <p>18 calle 1-65 zona 1</p>
                <p>Tel: 2204 4111</p>
              </div>

              <div className="footer-block">
                <p className="footer-title">Sucursal San Miguel Petapa</p>
                <p>Plaza San Diego, Calle Real 17-80, Zona 10<br />Local 116 San Miguel Petapa</p>
                <p>Tel: 3999 8656</p>
              </div>

              <div className="footer-block">
                <p className="footer-title">Sucursal Escuintla</p>
                <p>Escuintla, 1ra Calle 4-42, Zona 1</p>
                <p>Tel: 3999 8593</p>
              </div>
            </div>

            {/* Columna 3 */}
            <div>
              <div className="footer-block">
                <p className="footer-title">Sucursal Terminal Z 9</p>
                <p>1ra Calle 5-41 Zona 9</p>
                <p>Tel: 3999 8401</p>
              </div>

              <div className="footer-block">
                <p className="footer-title">Sucursal Calz. San Juan</p>
                <p>Calz. San Juan 4-46 Zona 3 de Mixco Local #9<br />Centro Comercial El Castaño</p>
                <p>Tel: 3999 1511</p>
              </div>

              <div className="footer-block">
                <p className="footer-title">Soporte al Cliente</p>
                <p>PBX: 2204 4111</p>
                <p>servicioalcliente@incaprosa.com.gt</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Copyright */}
      <div className="elementor-copy text-center">
        <p className="mb-0 py-3">
          <AiOutlineCopyrightCircle /> 2025 Incaprosa, S.A.|Todos los derechos reservados | Powered By YETI ADVISERS.
        </p>
      </div>
    </footer>
  );
};

export default StickyFooter;
